import * as types from '../mutation-types'

// state
export const state = {
  user: null,
  token: null,
  isAuthorized: false
};

// getters
export const getters = {
  user: state => state.user,
  token: state => state.token,
  check: state => state.user !== null,
  isAuthorized: state => state.isAuthorized,
};

// mutations
export const mutations = {
  [types.UPDATE_TOKEN](state, {token, remember}) {
    state.token = token;
    state.isAuthorized = true;
  },

  [types.FETCH_USER_SUCCESS](state, {user}) {
    state.user = user;
    state.isAuthorized = true;
  },

  [types.IS_AUTHORISED](state, status) {
    state.isAuthorized = !!status;
  },

  [types.FETCH_USER_FAILURE](state) {
    state.token = null;
    state.isAuthorized = false;
  },

  [types.LOGOUT](state) {
    state.user = null;
    state.token = null;
    state.isAuthorized = false;
  },

  [types.REMOVE_TOKEN](state) {
    state.token = null;
    state.isAuthorized = false;
  }
};

// actions
export const actions = {

  updateToken({commit, dispatch}, payload) {
    commit(types.UPDATE_TOKEN, payload)
  },

  removeToken({commit, dispatch}) {
    commit(types.REMOVE_TOKEN)
  },

  async logout({commit}) {
    commit(types.LOGOUT)
  }

};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js